import { useMemo } from "react";
import { Add, NotesRounded, Settings } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/common/PageHeader";
import { PageHub } from "@/components/common/PageHub";

/**
 * Hub de gestão de protocolos fora do atendimento.
 * Ativo quando !defaultApp (ex.: FluxVet standard). Permite gerenciar e criar
 * protocolos independentemente do atendimento (PrescriptionsStep / FluxVet).
 */
export function ProtocolSettings() {
  const navigate = useNavigate();

  const protocolCards = useMemo(
    () => [
      {
        title: "Gerenciar protocolos",
        icon: <Settings fontSize="large" sx={{ color: "primary800.main" }} />,
        description: "Consulte, edite e gerencie os protocolos salvos",
        onClick: () => navigate("/manageprotocol"),
      },
      {
        title: "Criar protocolo",
        icon: <Add fontSize="large" sx={{ color: "primary800.main" }} />,
        description: "Crie um protocolo novo",
        onClick: () => navigate("/createprotocol"),
      },
    ],
    [navigate],
  );

  const questionnaireCards = useMemo(
    () => [
      {
        title: "Gerenciar questionários",
        icon: <Settings fontSize="large" sx={{ color: "primary800.main" }} />,
        description: "Consulte, edite e gerencie os questionários salvos",
        onClick: () => navigate("/questionnaireManagement"),
      },
      {
        title: "Criar questionário",
        icon: <Add fontSize="large" sx={{ color: "primary800.main" }} />,
        description: "Crie um questionário novo",
        onClick: () => navigate("/questionnaireBuilder"),
      },
    ],
    [navigate],
  );

  return (
    <PageHub
      header={
        <PageHeader title="Protocolos clínicos" centered icon={NotesRounded} />
      }
      sections={[
        { title: "Protocolos", cards: protocolCards },
        { title: "Questionários", cards: questionnaireCards },
      ]}
    />
  );
}
